<template>
  <div class="contact">
    <div>
      <button class="btn-social facebook">
        <a href="https://www.facebook.com/afdal4935" target="_blank"
          ><i class="fa fa-facebook facebook facebook-icon">
            Contact on Facebook
          </i>
        </a>
      </button>
    </div>
    <button class="btn-social">
      <a href="https://instagram.com/afdal_h4935?r=nametag" target="_blank">
        <i class="fab fa-instagram-square instagram"> Contact on Instagram</i>
      </a>
    </button>
    <div></div>
    <div>
      <button class="btn-social">
        <a href="https://wa.me/971521212203" target="_blank">
          <i class="fab fa-whatsapp-square whatsapp"> Contact on Whatsapp</i>
        </a>
      </button>
    </div>
    <img :src="background" style="height: 400px" />
  </div>
</template>

<script>
// @ is an alias to /src
import background from "@/assets/back.jpeg";
export default {
  name: "Contact",
  components: {},
  data: function () {
    return {
      background,
    };
  },
};
</script>

<style>
.contact {
  background: #231f20;
}
.btn-social {
  width: 300px;
  height: 45px;
  margin: 20px;
  font-size: 18px;
  border: 0;
  border-radius: 8px;
}
.btn-social:hover {
  box-shadow: 0 12px 16px 0 rgba(0, 0, 0, 0.24),
    0 17px 50px 0 rgba(0, 0, 0, 0.19);
}
.facebook {
  color: blue !important;
}
.instagram {
  color: red !important;
}
.whatsapp {
  color: green !important;
}
</style>
